import { Modal } from 'components/common';
import { omniChatMessages } from 'messages';
import { ChatSessionDto, UserCompactDto } from 'types';
import { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { Button } from 'antd';
import OmniChatSessionWaitingAssignUser from './OmniChatSessionWaitingAssignUser';
import { useAssignChatSession } from 'hooks';
import { debounce } from 'lodash';
import { onReceiveChatSessionWaiting } from 'services';
import { CHAT_STATUS } from 'utils';

type OmniChatSessionAssignModalProps = {
  onCancel?: () => void;
  open?: boolean;
  chatSession: ChatSessionDto;
  afterAssign: () => void;
  onClose: () => void;
};

const OmniChatSessionAssignModal: React.FC<OmniChatSessionAssignModalProps> = ({
  onCancel,
  open,
  chatSession,
  afterAssign,
  onClose
}) => {
  const { onAssignChatSession, isLoading } = useAssignChatSession();
  const [userAssign, setUserAssign] = useState<UserCompactDto | undefined>();

  useEffect(() => {
    onReceiveChatSessionWaiting((data) => {
      if (data && data.chatSessionId === chatSession?.chatSessionId) {
        debounce(() => {
          if (data.status !== CHAT_STATUS.WAITING) {
            handleReset();
          }
        }, 100)();
      }
    });
  }, []);

  // useEffect(() => {
  //   console.log(chatSession);
  // }, [chatSession]);

  useEffect(() => {
    if (!open) {
      // setChatSessionAssign(undefined);
      // setAssign(false);
      setUserAssign(undefined);
    }
  }, [open]);

  const handleAssignChatSession = () => {
    if (chatSession && userAssign) {
      onAssignChatSession(chatSession.chatSessionId, userAssign.userId).then(() => {
        handleReset();
        afterAssign();
      });
    }
  };

  const handleReset = () => {
    // setChatSessionAssign(undefined);
    // setAssign(false);
    setUserAssign(undefined);
  };

  return (
    <Modal
      styles={{
        body: { padding: 0 }
      }}
      width={768}
      title={omniChatMessages.assignChat}
      open={open}
      onCancel={onCancel}
      onClose={onClose}
      centered
      maskClosable={false}
      destroyOnClose
      footer={
        <Button
          loading={isLoading}
          onClick={handleAssignChatSession}
          disabled={!chatSession || !userAssign}
          className='h-10 px-4'
          size='small'
          type='primary'
        >
          {omniChatMessages.confirmAssign}
        </Button>
      }
    >
      <div className='relative flex h-[calc(100vh-280px)] overflow-x-hidden'>
        <div className='relative flex h-full w-full overflow-hidden'>
          <div className={twMerge('absolute h-full w-full bg-white transition-all duration-200')}>
            {/* {chatSessionAssign ? ( */}
            <OmniChatSessionWaitingAssignUser
              selectedUserId={userAssign?.userId}
              onSelectUser={(userId, user) => setUserAssign(user)}
              onBack={() => {
                // setAssign(false);
                setUserAssign(undefined);
              }}
            />
            {/* ) : null} */}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default OmniChatSessionAssignModal;
